import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Briefcase, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";

export default function ApplicationsPage() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/applications/me").then((r) => setItems(r.data.items || []));
  }, []);
  return (
    <div className="container py-10">
      <p className="eyebrow mb-1">My Applications</p>
      <h1 className="display-2 mb-8">{items.length} applications tracked</h1>
      {items.length === 0 ? (
        <div className="vital-card-static p-10 text-center text-muted-foreground" data-testid="apps-empty">
          You haven't applied to any roles yet. <Link to="/jobs" className="text-primary underline">Browse jobs →</Link>
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((a) => (
            <div key={a.application_id} className="vital-card p-5 flex items-center gap-4" data-testid={`app-row-${a.application_id}`}>
              <div className="h-10 w-10 rounded-md bg-muted flex items-center justify-center"><Briefcase className="h-5 w-5" /></div>
              <div className="flex-1 min-w-0">
                <div className="font-bold truncate">{a.title}</div>
                <div className="text-xs text-muted-foreground">{a.company} · {new Date(a.created_at).toLocaleDateString()}</div>
              </div>
              {a.redirect_url && (
                <a href={a.redirect_url} target="_blank" rel="noreferrer" className="text-sm font-semibold text-primary inline-flex items-center gap-1">
                  Open <ExternalLink className="h-3 w-3" />
                </a>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
